import { render } from "./GoalsContainer.vue?vue&type=template&id=156aa344"
import script from "./GoalsContainer.vue?vue&type=script&lang=js"
export * from "./GoalsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/herodao/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__